import { MaskitoOptions } from '@maskito/core';

export const Regs = {
  URL: 'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)',
  IMAGE_URL: '^((?:https?:\\/\\/)?[^./]+(?:\\.[^./]+)+(?:\\/.*)?)$',
  DEEP_LINK:
    '(([a-z]{2,}:\\/\\/)(?:[^\\s()<>]+|\\(([^\\s()<>]+|' +
    '(\\([^\\s()<>]+\\)))*\\))+(?:\\(([^\\s()<>]+|(\\([^\\s()<>]+\\)))*\\)|[^\\s`!()\\[\\]{};:\'\\".,<>?«»“”‘’]))',
  YOUTUBE_LINK:
    'https?:\\/\\/(?:www\\.)?(?:youtu\\.be\\/|youtube\\.com(?:\\/watch\\?v=))([\\w\\-]{10,12})\\b(?:[-a-zA-Z0-9()@:%_\\+.~#?&\\/=]*)',
  HEX_REGEX: /#[0-9A-Fa-f]{6}/,
  EXT: /[.\/][0-9a-z]+$/i,
  IMAGE_TYPE: /image\/(jpg|png|gif|bmp|webp|jpeg)/
};

export const ObjectStorySpecTypes = ['template_data', 'video_data', 'link_data'];

export const LONG_DASH = '\u2014';
export const GRID_MIN_ROW_HEIGHT = 40;
export const GRID_HEADER_HEIGHT = 32;
export const GRID_SUMMARY_HEADER_HEIGHT = 0;
export const GAP_BEFORE_GRID = 25;
export const APP_FOOTER_HEIGHT = 47;
export const APP_HEADER_HEIGHT = 25;

export const EveryFourHoursCrontab = '0 */4 * * *';
export const cookiePrefix = 'ai_';
export const localStorageLocale = `${cookiePrefix}locale`;
export const localStorageUtm = `${cookiePrefix}Utm`;
export const localStorageOnboarding = `${cookiePrefix}onboarding`;
export const localStorageFontName = `${cookiePrefix}fontFamily`;
export const localStorageSelectedCatalog = `${cookiePrefix}selectedCatalog`;
export const localStorageItercomHintShown = `${cookiePrefix}itercomHintShown`;
export const catalogsTourKey = `${cookiePrefix}isTourShown`;

export const UNAUTH_TYPE = 'FacebookTokenUnauthorizedException';
export const FORBIDDEN_TYPE = 'FacebookTokenForbiddenException';
export const TWO_FACTOR = 'FacebookTwoFactorException';
export const BUSINESS_NOT_FOUND = 'FacebookBusinessNotFoundException';
export const FORBIDDEN_TEXT = 'Forbidden';

export const HEX_MASK: MaskitoOptions = {
  mask: ['#', ...new Array(6).fill(/\d|[a-f]|[A-F]/)]
};

export const HEXA_MASK: MaskitoOptions = {
  mask: ['#', ...new Array(8).fill(/\d|[a-f]|[A-F]/)]
};

export const PRODUCT_FIELDS = [
  { type: 'name', icon: 'productTitle', verticals: ['destinations', 'commerce', 'hotels'] },
  { type: 'brand', icon: 'productBrand', verticals: ['destinations', 'commerce', 'hotels'] },
  {
    type: 'address:region',
    icon: 'productRegion',
    verticals: ['destinations', 'hotels', 'vehicles']
  },
  { type: 'address:city', icon: 'productCity', verticals: ['destinations', 'hotels', 'vehicles'] },
  {
    type: 'address:country',
    icon: 'productCountry',
    verticals: ['destinations', 'hotels', 'vehicles']
  },
  { type: 'product_type', icon: 'productType', verticals: ['destinations', 'commerce', 'hotels'] },
  { type: 'price', icon: 'price', verticals: ['destinations', 'commerce', 'vehicles', 'hotels'] },
  { type: 'sale_price', icon: 'salePrice', verticals: ['commerce', 'vehicles', 'hotels'] },
  {
    type: 'actual_price',
    icon: 'actualPrice',
    verticals: ['destinations', 'commerce', 'vehicles', 'hotels']
  },
  {
    type: 'sale_value',
    icon: 'saleValue',
    verticals: ['destinations', 'commerce', 'vehicles', 'hotels']
  },
  {
    type: 'sale_percent',
    icon: 'salePercent',
    verticals: ['destinations', 'commerce', 'vehicles', 'hotels']
  },
  {
    type: 'product_image',
    icon: 'productImageLabel',
    verticals: ['destinations', 'commerce', 'hotels', 'vehicles']
  },
  {
    type: 'additional_image',
    icon: 'additionalImage',
    verticals: ['destinations', 'commerce', 'hotels', 'vehicles']
  },
  { type: 'custom_label_0', icon: 'customLabel0', verticals: ['commerce'] },
  { type: 'custom_label_1', icon: 'customLabel1', verticals: ['commerce'] },
  { type: 'custom_label_2', icon: 'customLabel2', verticals: ['commerce'] },
  { type: 'custom_label_3', icon: 'customLabel3', verticals: ['commerce'] },
  { type: 'custom_label_4', icon: 'customLabel4', verticals: ['commerce'] },
  { type: 'custom_number_0', icon: 'customNumber0', verticals: ['commerce'] },
  { type: 'custom_number_1', icon: 'customNumber1', verticals: ['commerce'] },
  { type: 'custom_number_2', icon: 'customNumber2', verticals: ['commerce'] },
  { type: 'custom_number_3', icon: 'customNumber3', verticals: ['commerce'] },
  { type: 'custom_number_4', icon: 'customNumber4', verticals: ['commerce'] }
];
